//import { _,Backbone,Obscura } from '../../vendor';
import { Biscuit } from "../utils";
import InboomaBaseAsyncCollection from "./InboomaBaseAsyncCollection";
import PaymentAccount from "../models/PaymentAccount";

export default InboomaBaseAsyncCollection.extend({
  collectionName: "paymentAccounts",
  model: PaymentAccount,
  url: "/payment_settings",

  initialize() {
    this.url += "/getByClientId/" + Biscuit.get("user.client_id");
    InboomaBaseAsyncCollection.prototype.initialize.apply(this);
  },
});
